import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "components/loader";
import UploadIcon from "assets/icons/upload_icon.svg";
export default function FileUploadPopUp({ openFilePopUp, setFilePopUp, onFileUpload, fileValue, fileStatus, handleDeleteFile, setStepsData }) {
  const [selectFile, setSelectFile] = useState(false);
  const handleClose = () => {
    if (fileValue.length === 0) {
      setSelectFile(true);
    } else {
      setSelectFile(false);
      setFilePopUp(false);
    }

    // setLoader(false)
  };
  return (
    <>
      {openFilePopUp && (
        <React.Fragment>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-primary">
            <div className="relative  flex items-center justify-between 2xl:w-5/12 lg:w-5/12 bg-white flex-col rounded-2xl py-14 w-11/12 sm:w-auto">
              <h5 className="font-secondary text-[30px] font-semibold mb-4">Upload your files</h5>
              <span
                onClick={() => {
                  setFilePopUp(false);
                  setSelectFile(false);
                }}
                className="text-black w-6 text-xl text-center leading-[18px] cursor-pointer  h-6 top-3 right-3  bg-white rounded-full border-2 border-black absolute "
              >
                x
              </span>
              <div className="xl:w-[482px]  w-full h-auto shadow_pop_up  p-10 flex items-center justify-center relative flex-col">
                <div className="w-full flex items-center justify-center">
                  <input multiple type="file" placeholder=".pdf, .docx, .txt" value="" className="inputfile " onChange={onFileUpload} onClick={() => setSelectFile(false)} />
                </div>

                <div className="flex flex-col sm:flex-row font-arial text-new text-quotetext-200 mb-8">
                  <div className="w-2/12 mr-2 font-arial mb-3 sm:mb-0">
                    <img src={UploadIcon} />
                  </div>
                  <div className="w-full sm:w-10/12 ">
                    Click to add your files (.pdf, .docx, .txt)
                    <br /> Maximum file upload size: 200mb
                  </div>
                </div>
                {selectFile ? <span className="text-center font-secondary text-red transition-all scale-110 duration-100">Please select File</span> : null}
                {fileStatus !== "loading" ? (
                  fileValue?.map(({ originalName, id, noOfWords }) => (
                    <div className="flex justify-between px-4 items-center w-full border mb-2 border-borderGray py-2 rounded-xl bg-[#F8F9F9]" key={id}>
                      <div className="flex flex-col gap-1 sm:flex-row">
                        <p className="text-14 sm:text-lg font-arial">{originalName} </p>
                        <p className="text-14 sm:text-lg font-arial">{`(${noOfWords} words)`}</p>
                      </div>
                      <FontAwesomeIcon icon={faTrash} className="text-red w-6 cursor-pointer" onClick={() => handleDeleteFile(id)} />
                    </div>
                  ))
                ) : fileStatus === "loading" ? (
                  <Loader />
                ) : null}
              </div>

              <button className="w-52 mt-8 rounded-3xl h-11 text-xl py-1 text-white bg-orange font-opensans font-bold block mx-auto" onClick={handleClose}>
                Continue
              </button>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </React.Fragment>
      )}
    </>
  );
}
